module.exports = __webpack_public_path__ + "img/25.be8934a4.jpg";